import {Flex} from "../../../../../../../shared/components/Layouts"
import {useDispatch, useSelector} from "react-redux";
import {controls, editControlDialog, hideEditControl, isLoading} from "../../../../store/slice";
import {Dialog, DialogContent, DialogTitle, TextField} from "@mui/material";
import {Typo} from "../../../../../../../shared/components/Typography";
import CloseIcon from '@material-ui/icons/Close';
// import {ButtonWithBackround} from "../../../../../../shared/components/ButtonWithBackground";
import {controlType} from "../../../../types";
import React, {useEffect, useState} from "react";
import {EditControl} from "../../../../store/actions";
import {LoadingButton} from "../../../../../../../shared/components/Basic/CommonButtons";


export const UpdateControlDialog = () => {
    const dispatch = useDispatch();

    const {isOpen, controlId} = useSelector(editControlDialog);
    const _controls = useSelector(controls);
    const isLoadingUpdate = useSelector(isLoading);

    const emptyControl: controlType = {
        name: '',
        group: '',
        category: '',
        description: [],
        id: null,
        origin: true,
        organizationId: null,
        visibility: null,
        evidences: [],
        foundInFrameworksCounter: 0,
    }

    const [form, updateForm] = useState<controlType>(emptyControl);
    const [currentControl, setCurrentControl] = useState<controlType>(emptyControl);

    useEffect(() => {
        const currControl = _controls.find(e => e.id === controlId);
        if(currControl){
            updateForm(currControl);
            setCurrentControl(currControl);
        }
        //eslint-disable-next-line
    }, [isOpen]);

    const handleClose = () => {
        dispatch(hideEditControl());
        updateForm(emptyControl);
    }

    const handleChange = (event:React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        updateForm((prevValues) => ({
            ...prevValues,
            [event.target.name]: event.target.value as string,
        }));
    };

    const handleChangeDesc = (event:React.ChangeEvent<HTMLInputElement>) => {
        updateForm((prevValues) => ({
            ...prevValues,
            description: [event.target.value as string],
        }));
    }

    // const handleSelectVisibility = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    //     updateForm((prevValues) => ({
    //         ...prevValues, visibility: value,
    //     }));
    // }

    const validateForm = (): boolean => {
        if(JSON.stringify(currentControl) === JSON.stringify(form)) return false;
        return(
            form.name.trim().length > 0 &&
            // form.group.trim().length > 0 &&
            // form.category.trim().length > 0 &&
            form.description.length > 0
        )
    }

    const onSave = () => {
        if(validateForm()) dispatch(EditControl({control: form}));
    }

    return(
        <Dialog
            maxWidth={'xl'}
            open={isOpen}
            onClose={handleClose}
        >
            <DialogTitle>
                <Flex w={'100%'} jc={'space-between'} ai={'center'}>
                    <Typo fontSize={'24px'} fontWeight={700} letterSpacing={'1.53px'} margin={'0 50px 0 0'}>{'Edit Control'}</Typo>
                    <CloseIcon onClick={handleClose} style={{cursor: 'pointer'}} />
                </Flex>
            </DialogTitle>

            <DialogContent>
                <Flex w={'40vw'} direction={'column'} m={'20px 0 0 0'}>
                    <TextField id="filled-basic" label={'Name'} required variant="outlined" sx={{margin: '0 0 20px 0'}} name={'name'} value={form.name} onChange={handleChange}/>
                    <TextField id="filled-basic" label={'Group'}  variant="outlined" sx={{margin: '0 0 20px 0'}} name={'group'} value={form.group} onChange={handleChange}/>
                    <TextField id="filled-basic" label={'Category'}  variant="outlined" sx={{margin: '0 0 20px 0'}} name={'category'} value={form.category} onChange={handleChange}/>
                    <TextField id="filled-basic" label={'Description'} required variant="outlined" multiline minRows={5} sx={{margin: '0 0 28px 0'}} value={form.description[0] || ''} onChange={handleChangeDesc}/>
                    <Flex w={'100%'} jc={'space-between'} ai={'center'}>
                        {/*<RadioGroup row value={form.visibility} onChange={handleSelectVisibility}>*/}
                        {/*    <FormControlLabel value="PRIVATE" control={<Radio />} label={t("Private") as string} />*/}
                        {/*    <FormControlLabel value="PUBLIC" control={<Radio />} label={t("Public") as string} />*/}
                        {/*    <FormControlLabel value="RESTRICTED" control={<Radio />} label={t("Restricted") as string} />*/}
                        {/*</RadioGroup>*/}

                        {/* <ButtonWithBackround
                            width={'154px'}
                            height={'40px'}
                            color={validateForm() ? '#FFA000' : 'gray'}
                            text={'SAVE'}
                            fontColor={'white'}
                            fontSize={'16px'}
                            fontWeight={600}
                            onClick={onSave}
                        /> */}
                        <LoadingButton disabled={!validateForm()} loading={isLoadingUpdate} sx={{textTransform: 'none', fontWeight: 700, fontSize: '16px', ml: 'auto'}} onClick={onSave}>
                            {'Save'}
                        </LoadingButton>
                    </Flex>
                </Flex>
            </DialogContent>
        </Dialog>
    )
}
